import Modal from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { ReactComponent as AssistantIcon } from "assets/img/icons/AI-assistant-colour.svg";
import { Scrollbar } from "react-scrollbars-custom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import copy from "copy-to-clipboard";
import { useToasts } from "react-toast-notifications";
import { useUserContext } from "store/contexts/userContext";
import LazyLoadImage from "components/LazyLoadImage";
import { useEffect } from "react";
import TeamService from "services/TeamService";
import Loader from "components/Loader";
import { useState } from "react";

const GeneratedNamesResponse = ({ query, handleModal }) => {
  const { addToast } = useToasts();
  const { user } = useUserContext();
  const [names, setNames] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await TeamService.generiaAIGen({
          query: query,
          type: "NAME-YOUR-IDEA",
        });
        setNames(response?.data?.data?.response?.actionItems ?? []);
        setLoading(false);
      } catch {
        addToast("Some error occurred.", {
          appearance: "error",
        });
        setLoading(false);
      }
    })();
  }, [query, addToast]);

  const copyText = async (text) => {
    const name = text.replace(/\d+\.\d*|\.?\d+/, ""); // remove initial number from the string
    copy(name);
    addToast(`${name} copied to your clipboard.`, {
      appearance: "success",
    });
  };

  return (
    <Modal
      open
      onClose={handleModal}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      showCloseIcon={false}
      center={true}
      classNames={{
        modalContainer: "modalContainer",
        modal: "createTaskModal",
      }}
    >
      <div className="generated-names-response-root">
        <div className="response-header">
          <div className="heading pr-3">
            A name generator that suggests cool names based on your provided
            idea
          </div>
          <CloseIcon onClick={handleModal} className="closeIcon" />
        </div>
        {loading && (
          <div className="loader-container">
            <Loader height={50} width={50} />
          </div>
        )}
        {!loading && names.length === 0 && (
          <div className="loader-container">
            <h6>
              Couldn't generate idea names for provided text,
              <br /> Please try again.{" "}
            </h6>
          </div>
        )}
        {!loading && names.length > 0 && (
          <div className="response-container">
            <div className="user-info">
              <div className="assistance-username">
                <LazyLoadImage
                  image={user?.avatar}
                  imageClassName="userAvatar"
                />
                {`${user.first_name} ${user.last_name}`}
              </div>
              <Scrollbar style={{ height: "80px", fontSize: "15px" }}>
                {query}
              </Scrollbar>
            </div>

            <div className="assistance-resp-root">
              <div className="assistance-heading">
                <AssistantIcon width={50} />
                Assistant
              </div>
              <Scrollbar style={{ height: "300px", fontSize: "15px" }}>
                {names.map((name) => (
                  <div
                    className="names-list-item"
                    role="button"
                    onClick={() => copyText(name)}
                  >
                    {name}{" "}
                    <FontAwesomeIcon className="copy-icon" icon={faCopy} />
                  </div>
                ))}
              </Scrollbar>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default GeneratedNamesResponse;
